import React from "react";
import "./common.css";
import CustomInput from "./CustomInput";

class TableCard extends React.Component {
  state = {};
  constructor() {
    super();
    this.changes = {};
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.jsonObj !== prevState.layout) {
      return { layout: nextProps.jsonObj }; // <- this is setState equivalent
    } else {
      return null;
    }
  }
  getInputNewData = (property, value) => {
    this.changes[property] = value;
    this.props.setCardsInfo(this.changes, this.state.layout.title);
  };
  renderInputs = inputSet => {
    if (this.state.layout !== undefined) {
      const item = inputSet.map((item, key) => {
        if (this.state[item.item.intemName] !== item) {
          this.setState({ [item.item.intemName]: item });
        }
        return (
          <CustomInput
            key={key}
            item={item}
            minWidth={item.size ? item.size : "50%"}
            size={item.size}
            handleNewData={this.getInputNewData}
            functions={this.props.functions}
          />
        );
      });
      return item;
    }
  };
  render() {
    return (
      <div className="custom-card">
        {this.state.layout &&
        !this.state.layout.hideTitle &&
        this.state.layout.title ? (
          <h4 className="title">{this.state.layout.title}</h4>
        ) : null}

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            flex: 1
          }}
        >
          {this.state.layout.titleRow
            ? this.renderInputs(this.state.layout.titleRow)
            : null}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "column",
              justifyContent: "flex-end",
              flex: 1,
              maxHeight: this.state.layout.tableSettings.maxHeight
            }}
          >
            {this.state.layout.titleCloumn
              ? this.renderInputs(this.state.layout.titleCloumn)
              : null}
            {this.state.layout.tableBody
              ? this.renderInputs(this.state.layout.tableBody)
              : null}
          </div>
        </div>
      </div>
    );
  }
}

export default TableCard;
